/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-01-08 09:36:06
 */
import { defineStore } from 'pinia'
import LangType from '@/utils/enums/LangType'
import { IArrayPorps } from '@/service/model/sendWarehouse'

const lang = navigator.language.slice(0, 2)
export const useSettingStore = defineStore('sysSetting', {
  state: () => ({
    collapsed: false,
    openKeys: [] as number[],
    selectedKeys: [] as number[],
    locale: (LangType[lang] ? lang : 'en') as keyof typeof LangType,
    /**翻译数据json */
    langJson: {} as Record<'ms' | 'en', any>,
    station: {
      printer: '',
      template: 1,
      language: 'CN',
      isShowLogo: true
    } as Record<string, any>,
    lodopStatus: false as boolean,
    pendingCountData: [] as string[],
    scanDataList: [] as any,
    visitorId: ''
  }),
  getters: {
    getCollapsed: (state) => state.collapsed,
    getOpenKeys: (state) => state.openKeys,
    getSelectedKeys: (state) => state.selectedKeys,
    getStation: (state) => state.station,
    getPrinter: (state) => state.station.printer,
    getScanDataList: (state) => state.scanDataList,
    getVisitorId: (state) => state.visitorId
  },
  actions: {
    
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    setOpenkeys(keys: number[]) {
      if (this.openKeys.length) return
      this.openKeys = keys
    },
    setSelectedKeys(keys: number[]) {
      this.selectedKeys = keys
    },
    setPrinter(printer: string) {
      this.station.printer = printer
    },
    setScanDataList(data: Array<IArrayPorps>) {
      this.scanDataList = data
    },
    setVisitorId(str: string) {
      this.visitorId = str
    }
  },
  persist: {
    storage: localStorage,
    paths: ['collapsed', 'locale', 'langJson', 'station', 'scanDataList', 'visitorId']
  }
})
